import Tooltip from '@components/Presentation/atoms/Tooltip';
import { useSelectedSlide } from '@components/Presentation/hooks/useSelectedSlide';
import Switch from '@molecules/Switch';
import { QuestionIcon } from '@phosphor-icons/react';
import React from 'react';

function OneAnswerPerPerson() {
  const selectedSlide = useSelectedSlide();
  const tooltipContentMap: Record<string, string> = {
    pollWithOptions: 'Your audience can vote for multiple options in the poll.',
    freeForm: 'Your audience can vote for multiple options in the poll.',
    map: 'Your audience can enter multiple locations in the chat.'
  };

  const tooltipContent =
    tooltipContentMap[selectedSlide.type] ||
    'StreamAlive will count multiple responses per participant.';
  return (
    <div className="flex">
      <div className="flex flex-1 text-sm flex-nowrap text-default-900">
        Allow multiple responses &nbsp;
        <Tooltip content={tooltipContent}>
          <QuestionIcon size={20}

            className='!text-default-400'
          />
        </Tooltip>
      </div>
      <Switch
        checked={!selectedSlide.setting.oneUoneV}
        onChange={(e) =>
          selectedSlide.handler.updateSetting('oneUoneV', !e.target.checked)
        }
        onClick={() => {}}
      />
    </div>
  );
}

export default OneAnswerPerPerson;
